import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PlotStepsSchema } from '../types/plotStepsSchema';

const initialState: PlotStepsSchema = {
    plotStepNumber: 1,
    stepData: '',
};
export const plotStepsSlice = createSlice({
    name: 'plotSteps',
    initialState,
    reducers: {
        selectedPlotStep: (state, action: PayloadAction<number>) => {
            state.plotStepNumber = action.payload;
        },
        addedPlotStepData: (state, action: PayloadAction<any>) => {
            state.stepData = action.payload;
        },
    },
});

export const { actions: plotStepsActions } = plotStepsSlice;
export const { reducer: plotStepsReducer } = plotStepsSlice;
